import {inlineError} from '@s-ui/decorators/lib/index.js'
import {UseCase} from '@s-ui/domain'

import {HTTPTransactionRepository} from '../Repositories/HTTPTransactionRepository.js'
import {InformAgreedPriceTradeRequestValueObject} from '../ValueObjects/InformAgreedPriceTradeRequestValueObject.js'

/**
 * @implements UseCase
 */
class InformAgreedPriceTradeTransactionsUseCase extends UseCase {
  #httpTransactionsRepository

  constructor({httpTransactionsRepository}) {
    super()
    this.#httpTransactionsRepository = httpTransactionsRepository
  }

  static create({config}) {
    return new InformAgreedPriceTradeTransactionsUseCase({
      httpTransactionsRepository: HTTPTransactionRepository.create({config})
    })
  }

  @inlineError
  async execute({price, tradeId}) {
    const informAgreedPriceTradeRequestValueObject = InformAgreedPriceTradeRequestValueObject.create({
      price: Number(price),
      tradeId
    })

    const [error] = await this.#httpTransactionsRepository.informAgreedPrice(informAgreedPriceTradeRequestValueObject)

    if (error) return Promise.reject(error)
  }
}

export const factory = InformAgreedPriceTradeTransactionsUseCase.create
